import FullClient from '../../models/client/fullClient.model';

interface BuildClientPayloadOptions {
  isNewClient: boolean;
  verTodosClientes: boolean;
  userId: string | null;
}

const buildClientPayload = (
  client: FullClient,
  options: BuildClientPayloadOptions
): FullClient => {
  const payload = { ...client };

  payload.roleId = options.verTodosClientes ? null : options.userId;

  if (options.isNewClient) {
    payload.aprovacao = null;
  }

  return payload;
};

export default buildClientPayload;
